/** A CMS slug must be a single URL segment, never a path/query/fragment. */
export function validContentSlug(value) {
  if (typeof value !== 'string') return '';
  const slug = value.trim();
  try {
    const decoded = decodeURIComponent(slug);
    if (
      !decoded ||
      decoded === '.' ||
      decoded === '..' ||
      /[\\/?#\s:]/u.test(decoded)
    )
      return '';
    return slug;
  } catch {
    return '';
  }
}

/** Build only verified translations, from the runtime locale configuration. */
export function localizedSlugParams(
  slugs,
  locales,
  currentLocale,
  currentSlug
) {
  const supported = new Set(
    (locales || []).map((locale) =>
      typeof locale === 'string' ? locale : locale.code
    )
  );
  const params = {};
  for (const [language, candidate] of Object.entries(slugs || {})) {
    const slug = validContentSlug(candidate);
    if (supported.has(language) && slug) params[language] = { slug };
  }
  const slug = validContentSlug(currentSlug);
  // During a language switch the old page data can still be present. Never
  // overwrite an API-provided target translation with the previous locale's slug.
  if (supported.has(currentLocale) && slug && !params[currentLocale]) {
    params[currentLocale] = { slug };
  }
  return params;
}

/** JSON-LD is raw script text: CMS content must never terminate the element. */
export function serializeJsonLd(value) {
  return JSON.stringify(value)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026');
}
